/*
  Bridge between the Polly chat widget (polly by mizziburlo) and the Shopify
  cart. Polly's embed script turns a card's "Add to cart" click inside its
  iframe into a `polly:add_to_cart` event on window; this adds the variant to
  the real cart, opens the cart drawer, and reports back with
  `polly:cart_result` so the card can show "Added" or the error. The chat's
  "View cart" (`polly:open_cart`) opens the same drawer.
*/
(function () {
  if (window.__pollyBridge) return;
  window.__pollyBridge = true;

  // Polly shows `message` on the card's button: keep it short (40 chars max).
  function respond(detail, result) {
    if (result.message) result.message = String(result.message).slice(0, 40);
    if (detail && typeof detail.respond === 'function') {
      try { detail.respond(result); return; } catch (e) {}
    }
    window.dispatchEvent(new CustomEvent('polly:cart_result', {
      detail: Object.assign({ request_id: detail && detail.request_id }, result)
    }));
  }

  function openCart(res) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.renderContents) {
      // The drawer keeps its contents in a <template> until first opened.
      if (!cartDrawer.querySelector('.drawer__inner') && typeof window.loadTemplateContent === 'function') {
        window.loadTemplateContent(cartDrawer);
      }
      cartDrawer.classList.remove('is-empty');
      try { cartDrawer.renderContents(res); } catch (e) {}
    }
  }

  // The chat's "View cart": open the drawer in place rather than leaving the
  // page. Without preventDefault, Polly's embed script navigates to /cart.
  window.addEventListener('polly:open_cart', function (e) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.open !== 'function') return;
    e.preventDefault();
    if (!cartDrawer.querySelector('.drawer__inner') && typeof window.loadTemplateContent === 'function') {
      window.loadTemplateContent(cartDrawer);
    }
    cartDrawer.open();
  });

  window.addEventListener('polly:add_to_cart', function (e) {
    var detail = e.detail || {};
    var id = Number(String(detail.variant_id || '').split('/').pop());
    var qty = Math.max(1, Math.min(10, Number(detail.quantity) || 1));
    if (!id) { respond(detail, { ok: false, message: 'Choose an option on its page' }); return; }

    var cartDrawer = document.querySelector('cart-drawer');
    var sections = cartDrawer && cartDrawer.getSectionsToRender
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          // Shopify's descriptions run long ("You can only add 3 …"); stock is the usual cause.
          respond(detail, { ok: false, message: res.status === 422 ? 'Not enough in stock' : 'Could not add' });
          return;
        }
        respond(detail, { ok: true, message: 'Added' });
        // The chat stays open: on desktop the drawer slides in beside it, on
        // mobile (full-screen chat) it is waiting when the chat is closed.
        openCart(res);
      })
      .catch(function () { respond(detail, { ok: false, message: 'Could not add' }); });
  });
})();
